import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'skc-separator',
  templateUrl: './separator.component.html',
  styleUrls: ['./separator.component.less']
})
export class SeparatorComponent implements OnInit {
  @Input('skc-separator') separator: string | TemplateRef<void> = '/';
  currentSeparatorTemplate: TemplateRef<void>;
  currentSeparatorChart = '/';

  constructor() {}

  ngOnInit() {
    if (this.separator instanceof TemplateRef) {
      this.currentSeparatorTemplate = this.separator as TemplateRef<void>;
    } else {
      this.currentSeparatorChart = this.separator;
    }
  }
}
